import { PlusIcon } from '@heroicons/react/24/outline'

export default function CreateMicroVolumeConfigButton({
    onClick = () => {},
    variant = 'default',
}) {
    const isEditVariant = variant === 'edit'

    return (
        <div
            className={
                isEditVariant
                    ? 'shrink-0 w-20 h-48 border border-gray-400 rounded-lg flex items-center justify-center cursor-pointer'
                    : 'mx-auto w-12 h-32 border border-gray-400 rounded-lg flex items-center justify-center cursor-pointer'
            }
            onClick={onClick}
        >
            <PlusIcon className={isEditVariant ? 'h-12 w-12 text-gray-400' : 'h-10 w-10 text-gray-400'} />
        </div>
    )
}
